module.exports = __webpack_public_path__ + "img/ayom_yom_no.fe1251d4.png";